import { RuntimeConfig } from '@/infra/env/getEnv'
import {
  initializeDatadogRum,
  setGlobalContextPropertiesForDatadogRum,
  setUserForDatadogRum,
} from '@/datadog-rum.config'
import { initializeDatadogLogs, setUserForDatadogLogs } from '@/datadog-logs.config'
import { UserSession } from '@/domains/auth/AuthenticationPort'

export const datadogIsEnabled = (runtimeConfig: RuntimeConfig) =>
  runtimeConfig.ENVIRONMENT !== 'local'

export const initializeDatadogServices = (runtimeConfig: RuntimeConfig, currentVersion: string) => {
  if (!datadogIsEnabled(runtimeConfig)) return

  initializeDatadogRum(runtimeConfig, currentVersion)
  initializeDatadogLogs(runtimeConfig)
  setGlobalContextPropertiesForDatadogRum()
}

export const setDatadogUser = (userSession: UserSession, runtimeConfig: RuntimeConfig) => {
  if (!datadogIsEnabled(runtimeConfig)) return

  setUserForDatadogRum(userSession)
  setUserForDatadogLogs(userSession)
}
